export const name = 'siteTranslationsService' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-translations' as const
export const MountedSiteTranslationsServicesSymbol = Symbol('MountedSiteTranslationsServices')
